import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { Button } from './UiComponents/button';

export const ScrollButtons: React.FC = () => {
  const [isUpVisible, setIsUpVisible] = useState(false);
  const [isDownVisible, setIsDownVisible] = useState(false);
  const scrollToTop = () => {
      window.scrollTo({ 
        top: 0, 
        behavior: 'smooth' 
      });
  };

  const scrollToNotes = () => {
      const notesSection = 
        document.querySelector('[data-section="student-notes"]') ||
        document.getElementById('student-notes') ||
        document.getElementsByClassName('student-notes')[0];

      if (notesSection) {
        notesSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      } else {
        const allDivs = document.querySelectorAll('div');
        allDivs.forEach(div => {
          if (div.textContent?.includes('Notes')) {
            div.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    
  };

  useEffect(() => {
    const toggleVisibility = () => {
      setIsUpVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  useEffect(() => {
    const toggleVisibility = () => {
      setIsDownVisible(window.scrollY < 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility
    );
  }
  , []);

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col ">
      {isUpVisible && (
        <Button 
          onClick={scrollToTop}
          className="bg-green-700 text-white p-4 rounded-full shadow-lg transition-colors"
          abbr="Sroll to Top"
          aria-label="Scroll to Top"
        >
          <ChevronUp />
        </Button>
      )}
      {isDownVisible && (
      <Button 
        onClick={scrollToNotes}
        className="bg-green-700 text-white p-4 rounded-full shadow-lg transition-colors"
        abbr="Sroll to Notes"
        aria-label="Scroll to Notes"
      >
        <ChevronDown />
      </Button>
      )}
    </div>
  );
};

export default ScrollButtons;
